var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmbulance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200 120a24 24 0 0 0-48 0v16h48ZM112 388a60 60 0 1 0 60 60 60.068 60.068 0 0 0-60-60Zm0 84a24 24 0 1 1 24-24 24 24 0 0 1-24 24ZM416 388a60 60 0 1 0 60 60 60.068 60.068 0 0 0-60-60Zm0 84a24 24 0 1 1 24-24 24 24 0 0 1-24 24Z",
    fill: "#16807D",
    opacity: 1,
    "data-original": "#16807D",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.732 337.95 440.3 310.732c-9.295-14.365-50.867-78.461-62.767-94.021A12 12 0 0 0 368 212h-56.584l-22.049-44.1a35.8 35.8 0 0 0-32.2-19.9H28a24.028 24.028 0 0 0-24 24v252a36.04 36.04 0 0 0 36 36h1.019a72 72 0 1 1 141.962 0h162.038a72 72 0 1 1 142.463-3.5A36.043 36.043 0 0 0 508 424v-64.584a23.868 23.868 0 0 0-13.268-21.466ZM240 284a12 12 0 0 1-12 12h-28v28a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-28h-28a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h28v-28a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v28h28a12 12 0 0 1 12 12Zm112 80h-15a12 12 0 0 1 0-24h15a12 12 0 0 1 0 24Zm62.73-51H336a12 12 0 0 1-12-12v-61a12 12 0 0 1 12-12h27.3a12 12 0 0 1 9.917 5.243c14.5 21.249 35.873 54.038 46.552 70.494A6 6 0 0 1 414.73 313Z",
    fill: "#16807D",
    opacity: 1,
    "data-original": "#16807D",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/ambulance.1c806d2495aa966bd952829890f0507c.svg";
export { ForwardRef as ReactComponent };